import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAppSettings } from '../../models/UserInfo';
import { userInfoApi } from '../../services/apiServices/user/userInfo';

interface AppState {
  theme: string;
  isSsr: boolean;
  isSevenDaysAvailable: boolean;
  isSuccess: boolean;
  settings: IAppSettings | null;
  isOpenPushNotifications: boolean;
  location: {
    pathname: string;
    search: string;
  };
}

const initialState: AppState = {
  theme: localStorage.getItem('theme') || 'light',
  isSsr: !window,
  isSevenDaysAvailable: false,
  isSuccess: false,
  settings: null,
  isOpenPushNotifications: false,
  location: {
    pathname: '',
    search: '',
  },
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    chooseTheme(state, action: PayloadAction<string>) {
      state.theme = action.payload;
      localStorage.setItem('theme', action.payload);
    },
    setSuccess(state, { payload }: PayloadAction<boolean>) {
      state.isSuccess = payload;
    },
    openPushNotification(state, { payload }: PayloadAction<boolean>) {
      state.isOpenPushNotifications = payload;
    },
    setLocation(state, { payload }: PayloadAction<{ pathname: string; search: string }>) {
      state.location.pathname = payload.pathname;
      state.location.search = payload.search;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(userInfoApi.endpoints.getAppSettings.matchFulfilled, (state, action) => {
      state.settings = action.payload;
    });
  },
});

export default appSlice.reducer;
